module.exports = __webpack_public_path__ + "static/sport/bgi-pc.f4fcd6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lottery/bgi-pc.jpg
// module id = zHxS
// module chunks = 0